var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.children.length
    ? _c(
        "ol",
        _vm._l(_vm.content.children, function (obj, index) {
          return _c(
            "li",
            { staticClass: "term-box" },
            [
              obj.children.length
                ? [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.parentIndexes[0] + 1) +
                        "." +
                        _vm._s(_vm.parentIndexes[1] + 1) +
                        ":" +
                        _vm._s(index + 1) +
                        "\n      "
                    ),
                    _c(
                      "div",
                      { staticClass: "term" },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(obj.header[0].content) +
                            "\n        "
                        ),
                        _c("Depth5Point", {
                          attrs: {
                            parentIndexes: _vm.parentIndexes.concat([index]),
                            content: obj,
                          },
                        }),
                        _vm._v(" "),
                        obj.tail.length
                          ? _c("p", [_vm._v(_vm._s(obj.tail[0].content))])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.parentIndexes[0] + 1) +
                        "." +
                        _vm._s(_vm.parentIndexes[1] + 1) +
                        ":" +
                        _vm._s(index + 1)
                    ),
                    _c("p", { staticClass: "term" }, [
                      _vm._v(_vm._s(obj.header[0].content)),
                    ]),
                  ],
            ],
            2
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }